import { Link } from 'react-router-dom'
import { company } from '@/config/company'
import { NAV_LINKS } from '@/config/nav'
import { getBoardUrl } from '@/utils/appBase'
import styles from './SiteFooter.module.css'

export function SiteFooter() {
  const year = new Date().getFullYear()

  return (
    <footer className={styles.footer}>
      <div className={`container ${styles.inner}`}>
        <div className={styles.grid}>
          <section className={styles.about}>
            <img src={company.logo} alt={company.name} width={56} height={56} />
            <p className={styles.brandName}>{company.name}</p>
            <p className={styles.legalName}>{company.legalName}</p>
            <p>{company.about}</p>
            <p className={styles.disclaimer}>
              {company.legalName} sitesinde yayınlanan kurlar yalnızca bilgilendirme amaçlıdır;
              yatırım tavsiyesi değildir. İşlem anındaki geçerli kur gişede teyit edilir.
            </p>
          </section>

          <nav className={styles.menu} aria-label="Alt menü">
            <h2>Menü</h2>
            <ul>
              {NAV_LINKS.map((link) => (
                <li key={link.to}>
                  <Link to={link.to}>{link.label}</Link>
                </li>
              ))}
              <li>
                <a href={getBoardUrl()}>Canlı Pano</a>
              </li>
            </ul>
          </nav>

          <section className={styles.contact}>
            <h2>İletişim</h2>
            <p className={styles.legalName}>{company.legalName}</p>
            <p>{company.address}</p>
            <p>
              <a href={`tel:${company.phoneTel}`}>{company.phone}</a>
            </p>
            <p>
              <a href={`mailto:${company.email}`}>{company.email}</a>
            </p>
          </section>
        </div>

        <div className={styles.bottom}>
          <p>
            © {year} {company.legalName}. Tüm hakları saklıdır.
          </p>
        </div>
      </div>
    </footer>
  )
}
